module.exports = __webpack_public_path__ + "img/trophy.75afce33.svg";